<template>
  <div class="submit-button">
    <button
      v-if="!$slots.custom"
      class="btn"
      :class="{ loading: dataIsLoading }"
      type="submit"
      :disabled="disabled"
      @click="submitForm"
    >
      {{ label }}
      <sui-loader v-if="dataIsLoading" active centered />
    </button>

    <slot name="custom" />

    <div v-if="!!$slots.remark" class="remark">
      <slot name="remark" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubmitButton',

  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
    label: {
      type: String,
      default: () => 'Submit',
    },
    isLoading: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      dataIsLoading: this.isLoading,
    }
  },

  watch: {
    isLoading(newValue) {
      this.dataIsLoading = newValue
    },
  },

  methods: {
    submitForm() {
      this.dataIsLoading = true
    },
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

.submit-button {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 0;

  .btn {
    @include button;

    margin: 0 1rem;
    max-width: 300px;
    width: fit-content;

    &.loading {
      cursor: not-allowed;
      opacity: 0.65;
      pointer-events: none;
    }
  }

  .remark {
    p {
      font-size: 0.85em;
      padding: 1rem 0;
      text-align: center;

      .link {
        color: $blue-primary;
        display: inline;
        font-weight: 700;
        margin: 0;
        padding: 0 10px;

        &:hover,
        &:focus {
          box-shadow: none;
          filter: contrast(150%);
          text-decoration: none;
        }
      }
    }
  }
}
</style>
